import { createContext, ReactNode, useContext, useState } from 'react';
import { IMeeting } from 'types';

// eslint-disable-next-line @rushstack/typedef-var
const BoardMemberView = createContext<
  | {
      currentTopicId: string | undefined;
      isDrawerOpen: boolean;
      setIsDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
      setCurrentTopicId: React.Dispatch<React.SetStateAction<string | undefined>>;
      meeting: IMeeting;
    }
  | undefined
>(undefined);

interface IBoardMemberViewProviderProps {
  meeting: IMeeting;
}

export const BoardMemberViewProvider: React.FC<
  IBoardMemberViewProviderProps & { children: React.ReactNode }
> = ({ meeting, children }) => {
  const [currentTopicId, setCurrentTopicId] = useState<string | undefined>(
    meeting?.topics?.[0]?.id || undefined
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <BoardMemberView.Provider
      value={{
        currentTopicId,
        setCurrentTopicId,
        meeting,
        isDrawerOpen,
        setIsDrawerOpen
      }}
    >
      {children}
    </BoardMemberView.Provider>
  );
};

export const useBoardMemberViewContext = () => {
  const context = useContext(BoardMemberView);

  if (!context) {
    throw new Error('useBoardMemberViewContext must be used within an BoardMemberViewProvider');
  }
  return context;
};
